export default __webpack_public_path__ + "static/media/Legal+Socreates.ffe07e2d.gif";